define('charts/layers/starred-layer',["require", "exports", "../../tracks/starred", "../../util/convert"], function (require, exports, starred, convert_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.StarredLayer = void 0;
    var StarredLayer = /** @class */ (function () {
        function StarredLayer(options) {
            this.options = options;
        }
        StarredLayer.prototype.init = function (chart) {
            // Add svg group
            this.svgGroup = chart.layers.space.append("g")
                .attr("class", "starred paths")
                .style("fill", "none")
                .style("opacity", 0.25);
            // Construct d3 line
            this.distanceLine = d3.line()
                .x(function (d) { return chart.xAxis.scale(convert_1.default.distance.localValue(d.x)); })
                .y(function (d) { return chart.yAxis[0].scale(convert_1.default.distance.localValue(d.y)); });
        };
        StarredLayer.prototype.update = function (chart) {
            var _this = this;
            if (starred.tracks) {
                starred.tracks.then(function (baselines) {
                    // Update the flight profile lines
                    var path = _this.svgGroup.selectAll("path.starred-path")
                        .data(baselines);
                    path.enter()
                        .append("path")
                        .attr("class", "starred-path")
                        .style("stroke", "#31c")
                        .style("stroke-width", "2px")
                        .merge(path)
                        .attr("d", function (d) { return _this.distanceLine(d.data); });
                    path.exit().remove();
                });
            }
        };
        StarredLayer.prototype.remove = function () {
            this.svgGroup.remove();
        };
        return StarredLayer;
    }());
    exports.StarredLayer = StarredLayer;
});
//# sourceMappingURL=/assets/javascripts/charts/layers/starred-layer.js.map;
